import data2dTableEditor from '@/datasets/data-sys/data-2d-table-editor.vue';
import dataJsonEditor from '@/datasets/data-sys/data-json-editor.vue';
import * as dataDefault from '@/datasets/data-sys/data-sys-table.js';
const datasets = [
    {
        title:'系统二维表数据集',
        name:'sys-2d-table',
        handler:dataDefault,
        editor:data2dTableEditor,
        format:'2d-table'
    },

    {
        title:'系统JSON数据集',
        name:'sys-json',
        handler:dataDefault,
        editor:dataJsonEditor,
        format:'json'
    }
]

export {datasets}